export default __webpack_public_path__ + "static/media/agency-hab-logo-50.png";